module.exports = __webpack_public_path__ + "img/Adaptaciones, Modificaciones y_o Conversiones.efd8adf9.svg";